// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3om5W","fileBtn":"File_fileBtn__3wSGi","closeBtn":"File_closeBtn__23SPS","fileSelected":"File_fileSelected__emAFa","disabled":"File_disabled__2pdaM"};